<template>
  <div class="giftcard-view">
    <v-app-bar id="header" app color="primary" dense :class="['header', 'primaryText--text']">
      <v-row>
        <v-col cols="2" align-self="end">
          <v-btn text @click="navBack()">{{ $t("close") }}</v-btn>
        </v-col>

        <v-col cols="8" class="d-flex justify-center align-center">
          <div>
            <v-toolbar-title
              class="header-title1"
              v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
              >{{ $store.getters.storeName }}</v-toolbar-title
            >
            <v-toolbar-title class="header-title2">{{ $t("giftcard") }}</v-toolbar-title>
          </div>
        </v-col>

        <v-col cols="2" align-self="end" style="text-align: right">
          <!-- <v-btn v-if="$store.getters.stripeEnabled && $store.state.member != null" text @click="addGiftcard()">{{ $t("add") }}</v-btn> -->
        </v-col>
      </v-row>
    </v-app-bar>

    <v-container>
      <v-list v-show="giftcards.length > 0">
        <v-list-item v-for="(gc, index) in giftcards" :key="index" @click="toGiftcardTrans(gc)">
          <v-list-item-content class="giftcard-container">
            <v-row align="center">
              <v-col cols="4" class="giftcard-code-title">
                {{ $t("cardno") }}
              </v-col>
              <v-col cols="8" class="giftcard-code">
                {{ gc.CardCode | secure }}
              </v-col>
            </v-row>

            <v-row xclass="giftcard-row" align="center">
              <v-col cols="4" class="giftcard-balance-title">
                {{ $t("balance") }}
              </v-col>
              <v-col cols="8" class="giftcard-balance">
                {{ gc.CurBalance | currency }}
              </v-col>
            </v-row>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>

      <v-list v-show="giftcards.length == 0">
        <v-list-item class="justify-center py-4">
          {{ $t("GIFTCARD.no_gift_card") }}
        </v-list-item>
      </v-list>

      <div v-if="$store.getters.memberStripeEnabled" class="d-flex justify-center mt-2">
        <v-btn class="ma-2" @click="addGiftcard('me')">{{ addForMeButtonTitle }}</v-btn>
        <v-btn class="ma-2" @click="addGiftcard('someone')">{{ addForSomeoneButtonTitle }}</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //giftcards: [],
    };
  },

  activated() {
    console.log("giftcard activated");

    this.dispatchAction("getGiftcards");
/*
    let memberCode = null;
    if (this.$store.state.member != null) {
      memberCode = this.$store.state.member.MemberCode;
    }
    if (memberCode != null) {
      this.rest_getMemberGiftcards(memberCode).then(resp => {
        if (resp.result == "ok" && resp.record != null) {
          this.giftcards = resp.record;
        } else {
          this.giftcards = [];
        }
      });
    } else {
      this.giftcards = [];
    }
*/
  },

  computed: {
    addForMeButtonTitle() {
      if (this.giftcards.length == 0) return this.$t("GIFTCARD.add_new");
      else return this.$t("GIFTCARD.reload");
    },

    addForSomeoneButtonTitle() {
      return this.$t("GIFTCARD.send_giftcard");
    },

    giftcards() {
      return this.$store.state.giftcards;
    }    
  },

  methods: {
    toGiftcardTrans(giftcard) {
      this.$root.memberGiftcardTransDialog(giftcard);
    },

    addGiftcard(recipient) {
      this.navName("GiftCardAdd", { recipient: recipient });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/member-giftcard-dialog.scss";

.container {
  max-width: 600px;
}
</style>
